export default __webpack_public_path__ + "static/media/Beh”rde_KuM.6a1c0967.png";